module.exports = __webpack_public_path__ + "assets/img/returnBtn-38c1431f.png";